
import locale_en from '/home/jenkins/workspace/Prod_style3d_Front_homesite/apps/main/locales/en.json'
import locale_index from '/home/jenkins/workspace/Prod_style3d_Front_homesite/apps/main/locales/index.json'
import locale_zh_45CN from '/home/jenkins/workspace/Prod_style3d_Front_homesite/apps/main/locales/zh-CN.json'
export default { "en":locale_en,"index":locale_index,"zh-CN":locale_zh_45CN }
